export const CreateItemLabel = 'Plaatsen';
export const EditItemLabel = 'Aanpassen';